import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { FormControl, Select, MenuItem, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  label: {
    textTransform: "uppercase",
    opacity: "0.5",
    padding: theme.spacing(0.25, 0, 0, 2),
    marginBottom: theme.spacing(-1.25),
    whiteSpace: "nowrap"
  },
  select: {
    padding: theme.spacing(0, 4, 0, 1),
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem"
    }
  },
  labelForW4: {
    textTransform: "uppercase",
    opacity: "0.5",
    padding: theme.spacing(0.25, 0, 0, 0),
    marginRight: theme.spacing(-2),
    marginBottom: theme.spacing(-1.25),
    whiteSpace: "nowrap"
  },
  icon: {
    opacity: "0.5",
    position: "unset"
  }
}));

function DropdownSelect(props) {
  const { options, value, label, onChange, widgetWidth, disabled } = props;
  const { t } = useTranslation();
  function getDropdownMenu() {
    function handleDropdownChange(event) {
      if (onChange) {
        onChange(event.target.value);
      }
    }

    return (
      <Box mb={-1.25} pr={1} pl={0}>
        <FormControl>
          <Select
            disabled={disabled}
            value={value}
            renderValue={value => (
              <Typography variant="body2">
                {value.label ? t(value.label) : t(value)}
              </Typography>
            )}
            onChange={handleDropdownChange}
            classes={{ select: classes.select, icon: classes.icon }}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "right"
              }
            }}
          >
            {!!options &&
              options.map((dropdownOption, index) => (
                <MenuItem value={dropdownOption} key={index}>
                  {dropdownOption.label
                    ? t(dropdownOption.label)
                    : t(dropdownOption)}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
    );
  }
  const classes = useStyles();
  let labelClass = classes.label;
  if (widgetWidth && widgetWidth === 4) {
    labelClass = classes.labelForW4;
  }
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-start"
      height="100%"
      alignItems="center"
      mt={-1.25}
    >
      {!!label && (
        <Typography classes={{ root: labelClass }} variant="caption">
          {label}
        </Typography>
      )}
      {getDropdownMenu()}
    </Box>
  );
}

export default DropdownSelect;

DropdownSelect.propTypes = {
  value: PropTypes.any.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  onChange: PropTypes.func,
  renderValue: PropTypes.func,
  disabled: PropTypes.bool
};
